import  ThemeSwitch  from '../wookie/misc/ThemeSwitch';

export default function NavTheme() {
  return (
    <div className='navTheme mb-4'>
      <ThemeSwitch drop={true} />
    </div>
  );
}
